import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div className="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />

          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-charterhall.webp"
            alt="Charterhall"
          />
        </p>
        <strong>
          The city’s civic offices and the hub for shops, artisans, and
          commerce.
        </strong>{" "}
        <em>
          Charterhall is the site of the first major construction in the city,
          in the days before the cataclysm. The old wall upon which was built
          the <strong>first lightning barrier</strong> in the Empire still
          stands in partial ruin around the district. The area is now home to
          the <strong>civic offices</strong> of the government including the{" "}
          <strong>courts, licensing and taxation</strong> offices,{" "}
          <strong>banks</strong>, and <strong>records</strong> archives. City
          officials and students at <strong>Charterhall University</strong> live
          here, along with the captains of Imperial industry who prefer to
          reside within sight of their fortunes.
        </em>
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-charterhall.webp"
          alt="Charterhall"
        />
        <table className="district-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Nutshell</strong>: Bellweather Crematorium, Charterhall
                University, civic offices, artisans, hub for shops.
                <br />
                <strong>Scene:</strong> Clerks and government workers rush to
                and fro, official papers bulging from their valises.
                <br />
                Wealthy bankers trundle past in heavy carriages with private
                bodyguards arrayed in clanking armor.
                <br />
                Students gather at street-corner cafes to discuss Iruvian
                politics, the tribal lineages of the Dagger Isles, and other
                esoteric matters.
                <br />
                <strong>Streets:</strong> Broad, clean, well-lit.
                <br />
                <em>
                  Clerk Street, Jayan Way, Dalmore Avenue, Imperial Avenue.
                </em>
                <br />
                <strong>Buildings:</strong> Imposing stone buildings with
                officious columns and classical sculptural motifs.
                <br />
                <strong>Factions</strong>
                <ul>
                  <li>1. City Council</li>
                  <li>2. The Hive</li>
                  <li>3. Spirit Wardens</li>
                  <li>4. Archive of Echoes</li>
                  <li>5. Bluecoats</li>
                  <li>6. Ministry of Preservation</li>
                  <li>7. Sparkrunners</li>
                </ul>
              </td>
              <td valign="top">
                <img
                  src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-traits-charterhall.webp"
                  alt="Charterhall district traits"
                />
                <br />
                <em>
                  The records in Charterhall can be of particular interest to
                  criminal sorts.
                </em>
                <br />
                <em>
                  Take a <strong>Devil's Bargain</strong> for{" "}
                  <strong>+1d</strong> to gather info here in exchange for{" "}
                  <strong>1 heat</strong> (the Bluecoats are always watching for
                  scoundrels like you).
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Charterhall Locations</h1>
        <strong>
          <u>Bellweather Crematorium</u>
        </strong>
        : The site of the spirit bells and the rookery for the deathseeker
        crows. Bodies recovered by the Spirit Wardens are incinerated in
        electroplasm here to destroy their ghosts.
        <br />
        <br />
        <strong>
          <u>Charter Wall</u>
        </strong>
        : Along the ruins of the old walls are a sprawl of artist colonies.
        Bohemian lovers of music and sculpture, these students are typically
        patronized by a single individual or family who expect their charges to
        master their craft and make art for their edification.
        <br />
        <br />
        <strong>
          <u>Charterhall University</u>
        </strong>
        : A dozen buildings have been converted into classrooms and dormitories
        for the students of this modest-seeming but nevertheless prestigious
        institution. The school’s massive Sparkwright Tower, where experts of
        spark-craft are trained, looms huge over the district, often belching
        fire and smoke from the more vigorous lessons.
        <br />
        <br />
        <strong>
          <u>Clerk Street</u>
        </strong>
        : The main avenue of the district is lined with imposing governmental
        structures of all sorts, tucked behind iron fences, patrolled by a mix
        of Bluecoats on the sidewalks and mounted Imperial cavalry on the
        grounds.
        <br />
        <br />
        <strong>
          <u>Jayan Park</u>
        </strong>
        : The great alchemist for whom this park is named contrived to formulate
        soil and seeds that could produce real, growing trees, without sunlight
        or radiant energy. They are horrifically toxic to all living things and
        must not be touched, but they still grow beautifully here, over 100
        years later.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClasses_Districts_Charterhall = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <div
                    class="bitdFont morkBorgText"
                    style={{ textAlign: "center" }}
                  >
                    💀{" "}
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-introduction"
                    >
                      Introduction
                    </a>{" "}
                    💀
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-districts"
                    >
                      Districts
                    </a>{" "}
                    💀
                  </div>
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClasses_Districts_Charterhall;
